import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import * as nearestStoreLinkBuilder from '../home/utilities/nearestStoreLinkBuilder';
import '../../../scss/pages/covid-response/main.scss';

function startup() {
    nearestStoreLinkBuilder.buildAllLinks();
}

onDomContentLoaded(() => {
    startup();
});
